import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ControlErrorsComponent } from '../control-errors/control-errors.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-recipe-name-modal',
    templateUrl: './recipe-name-modal.component.html',
    styleUrls: ['./recipe-name-modal.component.scss'],
    imports: [ReactiveFormsModule, ControlErrorsComponent, TranslatePipe]
})
export class RecipeNameModalComponent implements OnInit {
  recipeForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router, 
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.recipeForm = this.fb.group({
      name: ['', [Validators.required]],
      multilevel: [false]
    });
  }

  createNewRecipe() {
    this.router.navigate(['/my-naboo', 'new'], {
      queryParams: this.recipeForm.value
    });
    this.activeModal.close();
  }
  
}
